import styled$1 from 'styled-components';
import { VideoLoop, colorSet } from '@ccg/core';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';

const StyledBackgroundVideo = styled$1(VideoLoop)`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  pointer-events: none;
  background: ${colorSet('background')};

  video {
    width: 100%;
    height: 100%;
    mix-blend-mode: difference;
  }
`;

const BackgroundVideo = ({
  src
}) => /*#__PURE__*/React$1.createElement(StyledBackgroundVideo, {
  src: src,
  loop: true,
  autoPlay: true
});

BackgroundVideo.propTypes = {
  src: PropTypes$1.string.isRequired
};
BackgroundVideo.defaultProps = {};

export default BackgroundVideo;
